

























import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class HelpIcon extends Vue {
    /** Tooltip body. If empty, the icon is suppressed entirely. */
    @Prop({ default: "" }) text!: string;
    /** Slightly tighter spacing for inline placement next to a label. */
    @Prop({ default: false }) inline!: boolean;
}
